import { useSetRecoilState } from 'recoil';

import { copyToClipboard } from 'service/browser';

import { pageAlertConfigState } from 'components/common/PageAlert/PageAlert.state';
import { PageAlertVariant } from 'components/common/PageAlert/PageAlert.types';

/**
 * This hook provides standard success and error callbacks for copying to the clipboard that
 * display messages about the provided content type (such as a link or a value) in a PageAlert.
 * If you want to provide custom success and/or error callbacks, call 'copyToClipboard' directly.
 * 
 * @returns function that creates default callbacks and calls 'copyToClipboard'
 */
const useCopyToClipboard = () => {

  const setPageAlertConfig = useSetRecoilState(pageAlertConfigState);

  /**
   * @param content    the text to copy to the clipboard
   * @param type       the type of text, eg "JSON" or "value", as it would used in the middle of a sentence
   */
  const copy = (
    content: string,
    type = 'text',
  ) => {

    const successHandler = () => setPageAlertConfig({
      message: type[0].toUpperCase() + type.substring(1) + ' copied to clipboard',
      variant: PageAlertVariant.SUCCESS,
      autoHide: true,
    });

    const errorHandler = () => setPageAlertConfig({
      message: 'Could not copy ' + type + ' to clipboard',
      variant: PageAlertVariant.SUCCESS,
      autoHide: true,
    });

    copyToClipboard(content, successHandler, errorHandler);
  };

  return copy;
};

export default useCopyToClipboard;
